import Vue from 'vue'
import { Button } from 'vant'; // 导入vant组件库
import 'vant/lib/index.css'; // 导入样式文件
import App from './App.vue'
import store from './store/index'
import router from './router/index'
import {API_CODE, ORDERS_STATE, ORDER_SORT_TYPE, REQUEST_PAGE_LIMIT, CUSTOM_SORT_SEARCH, SALE_CUSTOM_ROAD,GOOD_TYPE} from "./store/mutation-types";
import './assets/scss/animate.scss'
import './assets/scss/style.scss'
import VueWechatTitle from "vue-wechat-title";
import VuePicker from 'vue-pickers'
import VueCookies from 'vue-cookies'

Vue.use(VueWechatTitle);
Vue.use(VuePicker);
Vue.use(Button); // 全局注册vant组件库


Vue.prototype.$API_CODE = API_CODE;
Vue.prototype.$ORDERS_STATE = ORDERS_STATE;
Vue.prototype.$ORDER_SORT_TYPE = ORDER_SORT_TYPE;
Vue.prototype.$REQUEST_PAGE_LIMIT = REQUEST_PAGE_LIMIT;
Vue.prototype.$CUSTOM_SORT_SEARCH = CUSTOM_SORT_SEARCH;
Vue.prototype.$SALE_CUSTOM_ROAD = SALE_CUSTOM_ROAD;
Vue.prototype.$GOOD_TYPE = GOOD_TYPE;

Vue.config.productionTip = false


Vue.use(VueCookies)
//配置默认过期日期:365天
VueCookies.config("365d");

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
